/**
 * WithProjectSubscription
 *
 * 路由包装组件，从路由参数中提取 projectId 并传给 ProjectSubscriptionProvider。
 * 当 projectId 不存在时直接渲染 children（不订阅）。
 *
 * 需求：7.1、7.3
 *
 * 用法：
 * <Route path="project/:projectId" element={
 *   <ProtectedRoute>
 *     <WithProjectSubscription>
 *       <ProjectPage />
 *     </WithProjectSubscription>
 *   </ProtectedRoute>
 * } />
 */

import React from 'react';
import { useParams } from 'react-router-dom';
import ProjectSubscriptionProvider from './ProjectSubscriptionProvider';

interface WithProjectSubscriptionProps {
  children: React.ReactNode;
}

const WithProjectSubscription: React.FC<WithProjectSubscriptionProps> = ({ children }) => {
  const { projectId } = useParams<{ projectId: string }>();

  if (!projectId) {
    // projectId 不存在时直接渲染 children（不订阅）
    return <>{children}</>;
  }

  return (
    <ProjectSubscriptionProvider projectId={projectId}>
      {children}
    </ProjectSubscriptionProvider>
  );
};

export default WithProjectSubscription;
